import getCurrentLocale from 'rlink-router/getCurrentLocale';
import getCurrentRegion from 'rlink-router/getCurrentRegion';

/**
 * Push a navigation state to the navigation engine
 *
 * @param  {BuildContext} buildContext          The current buildContext.
 * @param  {string}  options.view               The name of a view function.
 * @param  {object}  options.params             View params.
 * @param  {string}  options.transition         The name of a loading transition (optional).
 * @param  {string}  options.returnTransition   The name of a transition to use when navigating back into this view (usually the opposite of the forward transition - defaults to the same value as transition if transition is given).
 * @param  {Boolean} options.replaceNavState Should the current history item be replaced rather than a new one added? (default: false)
 * @return {Thunk}
 */
export default function pushToNavState (buildContext, {
    view,
    params = {},
    returnScrollPosition = typeof window !== 'undefined' && {top: window.scrollY, left: window.scrollX},
    transition = null,
    returnTransition = null,
    replaceNavState = false,
  }) {

  if (returnTransition === null && transition !== null) {
    returnTransition = transition;
  }

  return (dispatch, getState, {navigationEngine}) => {
    let routing = getState().routing;
    let currentLocale = getCurrentLocale(routing);
    let currentRegion = getCurrentRegion(routing);
    if (!params.locale) {
      params.locale = currentLocale;
    }
    if (!params.region) {
      params.region = currentRegion;
    }

    let navState = {
      view, params,
      transition, returnTransition,
      scrollPosition: returnScrollPosition,
    };

    if (replaceNavState) {
      navigationEngine.replaceCurrentNavState(navState);
    } else {
      navigationEngine.addNewNavState(navState);
    }
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/pushToNavState.js